import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'

Vue.use(Vuex)

const _store = new Vuex.Store({
    modules: {
        app,
        user,
    },
})

export default _store
